import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormlyModule } from '@ngx-formly/core';

import { SlideInOutWrapperComponent } from './slide-in-out-wrapper.component';

@NgModule({
  declarations: [SlideInOutWrapperComponent],
  imports: [
    CommonModule,
    FormlyModule.forChild({
      wrappers: [
        {
          name: 'slide-in-out',
          component: SlideInOutWrapperComponent,
        },
      ],
    }),
  ],
})
export class SlideInOutWrapperModule {}
